import { render, staticRenderFns } from "./FiltroPesquisaSetor.vue?vue&type=template&id=589ef3b6&scoped=true"
import script from "./FiltroPesquisaSetor.vue?vue&type=script&lang=js"
export * from "./FiltroPesquisaSetor.vue?vue&type=script&lang=js"
import style0 from "./FiltroPesquisaSetor.vue?vue&type=style&index=0&id=589ef3b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ef3b6",
  null
  
)

export default component.exports